export const allowedImagefile="The image must be a file of type: jpg, png, gif, jpeg."
export const maxImageSize="Maximum image size 10 mb"